/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Array, ArrayInterface } from "../Array";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "inputPointer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "gluePointer",
        type: "uint256",
      },
    ],
    name: "_joinReferenceType",
    outputs: [
      {
        internalType: "bytes",
        name: "tempBytes",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes16[]",
        name: "a",
        type: "bytes16[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "a",
        type: "bytes[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "a",
        type: "bytes4[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "a",
        type: "bytes[]",
      },
      {
        internalType: "bytes",
        name: "glue",
        type: "bytes",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "a",
        type: "bytes32[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes3[]",
        name: "a",
        type: "bytes3[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes8[]",
        name: "a",
        type: "bytes8[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "a",
        type: "string[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes2[]",
        name: "a",
        type: "bytes2[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16[]",
        name: "a",
        type: "uint16[]",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "a",
        type: "string[]",
      },
      {
        internalType: "string",
        name: "glue",
        type: "string",
      },
    ],
    name: "join",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Array__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Array> {
    return super.deploy(overrides || {}) as Promise<Array>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Array {
    return super.attach(address) as Array;
  }
  connect(signer: Signer): Array__factory {
    return super.connect(signer) as Array__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ArrayInterface {
    return new utils.Interface(_abi) as ArrayInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Array {
    return new Contract(address, _abi, signerOrProvider) as Array;
  }
}
